import axios from "axios";
import { API_URL } from "../App";

export const fetchUserData = async () => {
  const config = {
    method: "post",
    url: API_URL + `/session`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios(config);
    console.log("auth: ", response);
    if (response.data[0].error_msg) {
      throw new Error(response.data[0].error_msg);
    }
    return {
      userId: response.data[0].userId,
      user: response.data[0].user,
      fullName: response.data[0].fullName,
      email: response.data[0].email,
      group: response.data[0].group,
      city: response.data[0].city,
      cityName: response.data[0].cityName,
      expire: response.data[0].expire,
      is_active: response.data[0].is_active,
      phone: response.data[0].phone,
      veryf: response.data[0].veryf,
      email_veryf: response.data[0].email_veryf,
      birthyear: response.data[0].birthyear,
      type: response.data[0].type,
    };
  } catch (error) {
    return { isLogged: false };
  }
};
